import { content } from "@/i18n/content";
import { useLang } from "@/i18n/language";
import { Section, SectionHeading } from "./Primitives";

export function Experience() {
  const { lang } = useLang();
  const t = content[lang];

  return (
    <Section id="experience">
      <SectionHeading eyebrow={t.experience.eyebrow} title={t.experience.title} lead={t.experience.lead} />

      <ol className="mt-14 relative border-l border-border pl-6 md:pl-10">
        {t.experience.steps.map((s) => (
          <li key={s.n} className="relative pb-9 last:pb-0">
            <span className="absolute -left-[1.65rem] top-1.5 size-2.5 rounded-full bg-primary md:-left-[2.65rem]" />
            <div className="flex flex-col gap-1 md:flex-row md:items-baseline md:gap-6">
              <span className="text-sm font-semibold tracking-widest text-primary">{s.n}</span>
              <div>
                <h3 className="text-lg font-semibold">{s.title}</h3>
                <p className="mt-1 max-w-xl text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </Section>
  );
}
